import styled from 'styled-components';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from '../../types/type';
import { MODAL_TYPE, modalStore } from '../../store/modalStore';
import { useDateHook } from '../../hook/useDateHook';
import { infoStore, ParticipationStatus } from '../../store/infoStore';
import { isPc } from '../../utils';
import { mobileQuery } from '../../utils';
import { tabStore } from '../../store/tabStore';
import { useEffect } from 'react';

export const InfoTab = () => {
  const { mainInfo, sideInfo } = infoStore();
  const { isStartSatellite, isOverPrivacyDate, isSatelliteEnd, today, isStartSideEvent } =
    useDateHook();
  const { showModal, showIsVisibleEndDate, showPrivacyModal } = modalStore();
  const { mainTab, setMainTab, setSubTab } = tabStore();
  const isMobile = !isPc();

  const hasMainTicket = mainInfo.status === ParticipationStatus.CHECK_ELIGIBLE;
  const hasSideTicket = sideInfo.status === ParticipationStatus.CHECK_ELIGIBLE;
  const hasTicket = hasMainTicket || hasSideTicket;
  const notAgreed =
    mainInfo.status === ParticipationStatus.NOT_AGREED ||
    sideInfo.status === ParticipationStatus.NOT_AGREED;
  const isSideNotAgreed = sideInfo.status === ParticipationStatus.NOT_AGREED;
  const isMainNotAgreed = mainInfo.status === ParticipationStatus.NOT_AGREED;

  const switchTab = (mainTabStatus: MAIN_TAB_STATUS) => {
    if (notAgreed) {
      // 동의 기간이 지난 경우
      if (!isOverPrivacyDate) {
        showPrivacyModal();
      } else {
        showIsVisibleEndDate();
      }
    }

    // 새틀라이트 진행 안내 탭 클릭 시
    if (mainTabStatus === MAIN_TAB_STATUS.PROGRESS) {
      // 아직 탭이 열리지 않은 경우 (4월 29일 이전)
      if (!isStartSatellite()) {
        showModal({ modalType: MODAL_TYPE.NOT_START });
        return;
      }
    }

    // 오프라인 이벤트 참가 안내 클릭 시
    if (mainTabStatus === MAIN_TAB_STATUS.MAIN_EVENT) {
      // 아직 탭이 열리지 않은 경우 (4월 29일 이전)
      if (!isStartSatellite()) {
        showModal({ modalType: MODAL_TYPE.NOT_START });
        return;
      }

      const mainTicketAvailable = mainInfo.status === ParticipationStatus.CHECK_ELIGIBLE;
      const sideTicketAvailable = sideInfo.status === ParticipationStatus.CHECK_ELIGIBLE;

      // 메인 또는 사이드 티켓이 있으면 해당 탭으로 이동
      if (mainTicketAvailable || sideTicketAvailable) {
        setMainTab(mainTabStatus);
        return;
      }

      // 두 티켓 모두 없는 경우
      showModal({ modalType: MODAL_TYPE.CHECK_ANY_TICKET });
      return;
    }

    window.scrollTo({ top: 0 });
    setMainTab(mainTabStatus);
  };

  useEffect(() => {
    if (isPc()) {
      if (isStartSatellite()) {
        if (isSatelliteEnd()) {
          setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
          setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_OFFLINE);
        } else {
          setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
          setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_ONLINE);
        }
      } else {
        setMainTab(MAIN_TAB_STATUS.REWARD);
        setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_ONLINE);
      }
    } else {
      if (isStartSatellite()) {
        if (hasTicket) {
          setMainTab(MAIN_TAB_STATUS.MAIN_EVENT);
          if (hasSideTicket) {
            setSubTab(MAIN_TAB_STATUS.PROGRESS, SUB_TAB_STATUS.PROGRESS_SIDE);
            setSubTab(MAIN_TAB_STATUS.MAIN_EVENT, SUB_TAB_STATUS.MAIN_EVENT_SIDE);
            return;
          }

          if (hasMainTicket) {
            setSubTab(MAIN_TAB_STATUS.PROGRESS, SUB_TAB_STATUS.PROGRESS_MAIN);
            setSubTab(MAIN_TAB_STATUS.MAIN_EVENT, SUB_TAB_STATUS.MAIN_EVENT_MAIN);
            return;
          }
          return;
        } else {
          if (notAgreed) {
            setMainTab(MAIN_TAB_STATUS.PROGRESS);
            if (isSideNotAgreed) {
              setSubTab(MAIN_TAB_STATUS.PROGRESS, SUB_TAB_STATUS.PROGRESS_SIDE);
              setSubTab(MAIN_TAB_STATUS.MAIN_EVENT, SUB_TAB_STATUS.MAIN_EVENT_SIDE);
            }
            if (isMainNotAgreed) {
              setSubTab(MAIN_TAB_STATUS.PROGRESS, SUB_TAB_STATUS.PROGRESS_MAIN);
              setSubTab(MAIN_TAB_STATUS.MAIN_EVENT, SUB_TAB_STATUS.MAIN_EVENT_MAIN);
            }
            return;
          }
        }

        if (isSatelliteEnd()) {
          setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
          setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_OFFLINE);
        } else {
          setMainTab(MAIN_TAB_STATUS.PARTICIPATE);
          setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_ONLINE);
        }

        if (isStartSideEvent()) {
          setSubTab(MAIN_TAB_STATUS.PROGRESS, SUB_TAB_STATUS.PROGRESS_SIDE);
        } else {
          setSubTab(MAIN_TAB_STATUS.PROGRESS, SUB_TAB_STATUS.PROGRESS_MAIN);
        }
      } else {
        setMainTab(MAIN_TAB_STATUS.REWARD);
        setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_ONLINE);
      }
    }
  }, [today]);

  return (
    <TabContainer>
      <Tab
        onClick={() => switchTab(MAIN_TAB_STATUS.REWARD)}
        $isActive={mainTab === MAIN_TAB_STATUS.REWARD}
      >
        <TabText $isActive={mainTab === MAIN_TAB_STATUS.REWARD}>
          토너먼트{` `}
          <span>상금 안내</span>
        </TabText>
      </Tab>

      <Tab
        onClick={() => switchTab(MAIN_TAB_STATUS.PARTICIPATE)}
        $isActive={mainTab === MAIN_TAB_STATUS.PARTICIPATE}
      >
        <TabText $isActive={mainTab === MAIN_TAB_STATUS.PARTICIPATE}>
          <span>토너먼트</span>
          {` `}
          참가 안내
        </TabText>
      </Tab>

      {isMobile && (
        <Tab
          onClick={() => switchTab(MAIN_TAB_STATUS.PROGRESS)}
          $isActive={mainTab === MAIN_TAB_STATUS.PROGRESS}
        >
          <TabText $isActive={mainTab === MAIN_TAB_STATUS.PROGRESS}>새틀라이트</TabText>
        </Tab>
      )}

      {isMobile && (
        <Tab
          onClick={() => switchTab(MAIN_TAB_STATUS.MAIN_EVENT)}
          $isActive={mainTab === MAIN_TAB_STATUS.MAIN_EVENT}
        >
          <TabText $isActive={mainTab === MAIN_TAB_STATUS.MAIN_EVENT} $isLast>
            오프라인
            <br />
            이벤트
          </TabText>
        </Tab>
      )}
    </TabContainer>
  );
};

const TabContainer = styled.div`
  display: flex;
  position: relative;
  z-index: 2;
  left: 0px;
  max-width: 800px;
  margin: 0 auto;
`;

const Tab = styled.div<{ $isActive: boolean }>`
  height: 68px;
  flex: 1;
  background: ${({ $isActive }) => ($isActive ? '#302e2d' : '#1C1B1B')};
  border: 0.5px solid #3c3c3c;
  ${({ $isActive }) => ($isActive ? 'border-bottom: none' : '')};
  border-top: 1px solid #3c3c3c;
  text-align: center;
  cursor: pointer;
  transition: 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:last-child {
    margin-right: 0;
  }

  ${mobileQuery} {
    height: 40px;
  }
`;

const TabText = styled.h4<{ $isActive: boolean; $isLast?: boolean }>`
  font-family: 'GmarketSans';
  font-weight: ${({ $isActive }) => ($isActive ? 900 : 500)};
  font-size: 24px;
  line-height: 26px;
  color: ${({ $isActive }) => ($isActive ? '#FFF1C9' : '#868686')};

  span {
    font-family: 'GmarketSans';
  }

  ${mobileQuery} {
    font-size: ${({ $isLast }) => ($isLast ? 12 : 15)}px;
    line-height: 15px;

    span {
      display: none;
    }
  }
`;
